import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function RequireAuth({ children }) {
  const { token, loading } = useAuth()
  const loc = useLocation()
  if (loading) return null
  if (!token) return <Navigate to="/login" state={{ from: loc }} replace />
  return children
}
